<template>
    <div>
        <div class="info_header">
            <el-button type="text" icon="el-icon-back" :style="{fontSize: '14px'}" @click="closePage">返回</el-button>
            <span class="text pl10 pr10 font14px">|</span>
            <span class="text pr10 font14px">{{ title }}</span>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'infoHeader',
    props:{
      title: String
    },
    data() {
        return {

        }
    },
    methods: {
        closePage() {
            // this.$router.back()
            this.$emit('backPage')
        }
    }
}
</script>
<style lang="scss" scoped>
    .info_header{
        background-color: #fff;
        padding: 4px 8px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        //position: fixed;
        //top: 60px;
        //z-index: 3;
        box-shadow: 0px 1px 2px #d9d9d9;
    }
</style>
